var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('draggable', {
    attrs: {
      "handle": ".handle"
    },
    on: {
      "input": _vm.emit
    },
    model: {
      value: _vm.items,
      callback: function ($$v) {
        _vm.items = $$v;
      },
      expression: "items"
    }
  }, _vm._l(_vm.items, function (item, index) {
    return _c('tags-item', _vm._g(_vm._b({
      key: item.tempId,
      on: {
        "input": _vm.emit
      },
      model: {
        value: _vm.items[index],
        callback: function ($$v) {
          _vm.$set(_vm.items, index, $$v);
        },
        expression: "items[index]"
      }
    }, 'tags-item', {
      showsDivider: index < _vm.items.length - 1
    }, false), {
      pull: _vm.pull
    }));
  }), 1), _c('v-divider'), _c('v-row', {
    staticClass: "justify-end",
    attrs: {
      "no-gutters": ""
    }
  }, [_c('v-divider', {
    attrs: {
      "vertical": ""
    }
  }), _c('v-btn', {
    attrs: {
      "icon": "",
      "tile": "",
      "width": "40",
      "min-height": "40",
      "color": "primary"
    },
    on: {
      "click": _vm.push
    }
  }, [_c('v-icon', [_vm._v("mdi-plus")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }